import { render, staticRenderFns } from "./TopicTitle.vue?vue&type=template&id=af5a4252&scoped=true"
import script from "./TopicTitle.vue?vue&type=script&lang=js"
export * from "./TopicTitle.vue?vue&type=script&lang=js"
import style0 from "./TopicTitle.vue?vue&type=style&index=0&id=af5a4252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5a4252",
  null
  
)

export default component.exports